import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";
import { sanitizeStoredFieldValue } from "../utils/richText";

function withSanitizedValue(payload) {
  if (!payload || typeof payload !== "object") return payload;
  return {
    ...payload,
    value: sanitizeStoredFieldValue(payload.value, {
      fieldType: payload.fieldType,
      key: payload.key,
      isRichText: payload.isRichText,
    }),
  };
}

export async function listFields(sectionId) {
  const response = await axiosClient.get(
    `/api/admin/sections/${sectionId}/fields`
  );
  return unwrapApiResponse(response);
}

export async function createField(sectionId, payload) {
  const response = await axiosClient.post(
    `/api/admin/sections/${sectionId}/fields`,
    withSanitizedValue(payload)
  );
  return unwrapApiResponse(response);
}

export async function updateField(fieldId, payload) {
  const response = await axiosClient.put(
    `/api/admin/fields/${fieldId}`,
    withSanitizedValue(payload)
  );
  return unwrapApiResponse(response);
}

export async function deleteField(fieldId) {
  const response = await axiosClient.delete(`/api/admin/fields/${fieldId}`);
  return unwrapApiResponse(response);
}
